import script from "./AttachmentPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./AttachmentPanel.vue?vue&type=script&setup=true&lang=ts"

import "./AttachmentPanel.vue?vue&type=style&index=0&id=40ec8027&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40ec8027"]])

export default __exports__